export default __webpack_public_path__ + "static/media/full-layer-image.ff619c5f.png";